module.exports = __webpack_public_path__ + "img/logoWhiteH.255740e6.png";